import { Injectable } from '@angular/core';
import { gql, Apollo } from 'apollo-angular';
import { pluck } from 'rxjs/operators';
const getSupplyBrandsQuery = gql`query get_supply_brands{
  supply_brands{
    id
    name
    created_at
    updated_at
  }
}`;
@Injectable()
export class GetSupplyBrandsService {
  /* ------------------------------- Constructor ------------------------------ */
  constructor(private apollo: Apollo) { }
/* -------------------------- Get Supply Categories ------------------------- */
  getSupplyBrands(){
    return this.apollo.use('external').query({
      query: getSupplyBrandsQuery
    }).pipe(pluck('data', 'supply_brands'))
  }
}
